/**
 * This app uses a sessionId in:
 * - sessionStorage -> to keep track of browser sessions (if browser closes, sessionId is lost)
 * - localStorage -> to keep track of unauthenticated users (guests) and their shopping carts
 */

import { API_URL } from '@constants';
import { getHeaders } from '@hooks/useApiConfig';

/* FOR SESSION ID IN LOCAL STORAGE */

export const getSessionId = () => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = generateSessionId();
        localStorage.setItem('sessionId', sessionId);

        fetch(`${API_URL}/user-logs/log-session`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ session_id: sessionId }),
        }).catch(() => {

        });
    }
    return sessionId;
};

/* FOR SESSION ID IN SESSION STORAGE */

export const isNewBrowserSession = (): boolean => {
    const sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
        // Set a new session identifier if it doesn't exist
        sessionStorage.setItem('sessionId', generateSessionId());
        return true;
    }
    return false;
};

// Generates a version 4 UUID
const generateSessionId = () => {
    // cspell:disable-next-line
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
